export default __webpack_public_path__ + "static/media/ifram.ab1ac77c.jpg";